import * as React from "react";
import {useLocation} from "react-router-dom";
import {AvailableMassivePatch} from "./MassiveActionsTypesAndFunctions";
import {NotAvailableMassiveAction} from "./NotAvailableMassiveAction";

export const ProtectedRoute = ({availableMassivePatches, children}) => {
    const location = useLocation();
    const patch = (availableMassivePatches as AvailableMassivePatch[])
        .find(availablePatch => availablePatch.name === location.pathname.replace("/", "") && availablePatch.available);
    if (patch === undefined) {
        return <NotAvailableMassiveAction/>
    }
    return children;
};